export default __webpack_public_path__ + "static/area-guid_img_t-7abf801d9ff4f69aadeaf51c825e625a.jpg";